export function zeigaku(kazeiIsangaku) {
    if (kazeiIsangaku > 60000) {
        return [kazeiIsangaku * 0.55 - 7200, 0.55];
    } else if (kazeiIsangaku > 30000) {
        return [kazeiIsangaku * 0.5 - 4200, 0.5];
    } else if (kazeiIsangaku > 20000 && kazeiIsangaku <= 30000) {
        return [kazeiIsangaku * 0.45 - 2700, 0.45];
    } else if (kazeiIsangaku > 10000 && kazeiIsangaku <= 20000) {
        return [kazeiIsangaku * 0.4 - 1700, 0.4];
    } else if (kazeiIsangaku > 5000 && kazeiIsangaku <= 10000) {
        return [kazeiIsangaku * 0.3 - 700, 0.3];
    } else if (kazeiIsangaku > 3000 && kazeiIsangaku <= 5000) {
        return [kazeiIsangaku * 0.2 - 200, 0.2];
    } else if (kazeiIsangaku > 1000 && kazeiIsangaku <= 3000) {
        return [kazeiIsangaku * 0.15 - 50, 0.15];
    } else if (kazeiIsangaku <= 1000 && kazeiIsangaku > 0) {
        return [kazeiIsangaku * 0.1, 0.1];
    } else if (kazeiIsangaku <= 0) {
        return [0, 0];
    }
}

export function calculate(isansougaku, haiguusha, child) {
    const kisoKoujyo = 3000 + (600 * (child + haiguusha));
    let kazeiIsangaku = Number(isansougaku) * 100 - kisoKoujyo;
    if (kazeiIsangaku <= 0) {
        kazeiIsangaku = 0;
    }
    let haiguusha_kazeiIsangaku, child_kazeiIsangaku, zeiSougaku = 0;
    if (haiguusha === 1) {
        haiguusha_kazeiIsangaku = kazeiIsangaku / 2;
        child_kazeiIsangaku = kazeiIsangaku / 2 / child;
        zeiSougaku = Math.round((zeigaku(haiguusha_kazeiIsangaku)[0] + Math.round(zeigaku(child_kazeiIsangaku)[0] * child)) / 2);
    } else if (haiguusha === 0) {
        haiguusha_kazeiIsangaku = 0;
        child_kazeiIsangaku = kazeiIsangaku / child;
        zeiSougaku = Math.round(zeigaku(child_kazeiIsangaku)[0] * child);
    }
    let jikkouZeiritsu = 0;
    if (zeiSougaku > 0) {
        jikkouZeiritsu = Math.round((zeiSougaku / (isansougaku * 100) * 100) * 10) / 10;
    }
    let result1 = [];
    result1[0] = { name: '子一人当たり課税遺産額', value: `${new Intl.NumberFormat().format(Math.round(child_kazeiIsangaku))} 万円` };
    result1[1] = { name: '相続税の総額', value: `${new Intl.NumberFormat().format(zeiSougaku)} 万円` };
    result1[2] = { name: '実効税率', value: `${jikkouZeiritsu} %` };
    result1[3] = { name: '配偶者の限界税率', value: `${Math.round(zeigaku(haiguusha_kazeiIsangaku)[1] * 100)} %` };
    result1[4] = { name: '子の限界税率', value: `${Math.round(zeigaku(child_kazeiIsangaku)[1] * 100)} %` };

    let result2 = [];
    result2[0] = Math.round(haiguusha_kazeiIsangaku);
    result2[1] = Math.round(child_kazeiIsangaku);
    result2[2] = zeiSougaku;

    let result = [result1, result2];

    // デバッグ用 
    // console.log(`isansougaku:${Number(isansougaku) * 100}`);
    // console.log('haiguusha:', haiguusha);
    // console.log('child:', child);
    // console.log('kisoKoujyo:', kisoKoujyo, typeof kisoKoujyo);
    // console.log('kazeiisangaku:', kazeiIsangaku);
    // console.log('haiguusha_kazeiIsangaku', haiguusha_kazeiIsangaku);
    // console.log(result);
    return result;
}